module.exports = new __parcel__URL__("koala.1effaaf1.svg").toString();